// ACHTUNG: Bei Aenderungen dieses Typs bitte auch die Parallelstelle im C#-SDK anpassen. Der Typ ist sowohl im Frontend
// als auch im externen Software-Partner-Kontext relevant. Er wird zur Kommunikation per postMessage von der eingebetteten
// Portal.Gui (iframe) an die Host-Software verwendet und kann daher nicht per NSwag generiert werden, da er nicht Teil
// einer HTTP-basierten Schnittstelle ist.
//
// Hinweis: Der Item-Export-Outbound nutzt aus historischen Gruenden weiterhin ISoftwarepartnerApiMessage mit dem
// number-basierten SoftwarepartnerApiInteractionType-Enum. Neue Outbound-Nachrichten gehoeren in dieses File.
export enum SoftwarepartnerApiOutboundMessageType {
	Ready = 'ready',
	CurrentLocation = 'currentLocation',
}

export type ISoftwarepartnerApiOutboundMessage =
	| { type: SoftwarepartnerApiOutboundMessageType.Ready }
	| { type: SoftwarepartnerApiOutboundMessageType.CurrentLocation; url: string };
